(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["journal-hero-slider"] && !Shopify.designMode) return;
  try {
    
/** code **/
class SqshJournalSlider extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-sqsh-slide]'));
    this.count = this.slides.length;
    if (this.count <= 1) return;

    this.index = 0;
    this.prevBtn = this.querySelector('[data-sqsh-prev]');
    this.nextBtn = this.querySelector('[data-sqsh-next]');
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.speed = (parseInt(this.getAttribute('autoplay-speed'), 10) || 6) * 1000;
    this.shouldAutoplay = this.hasAttribute('autoplay') && !this.reduceMotion;

    this._onPrev = () => { this.go(this.index - 1); this.restart(); };
    this._onNext = () => { this.go(this.index + 1); this.restart(); };
    this._onKey = (e) => {
      if (e.key === 'ArrowLeft') this._onPrev();
      if (e.key === 'ArrowRight') this._onNext();
    };

    if (this.prevBtn) this.prevBtn.addEventListener('click', this._onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this._onNext);
    this.addEventListener('keydown', this._onKey);
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());

    this.start();
  }

  go(next) {
    this.index = (next + this.count) % this.count;
    this.slides.forEach((slide, i) => {
      const active = i === this.index;
      slide.classList.toggle('is-active', active);
      if (active) {
        slide.removeAttribute('aria-hidden');
      } else {
        slide.setAttribute('aria-hidden', 'true');
      }
    });
  }

  start() {
    if (!this.shouldAutoplay) return;
    this.stop();
    this.timer = window.setInterval(() => this.go(this.index + 1), this.speed);
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
  }

  restart() {
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('sqsh-journal-slider')) {
  customElements.define('sqsh-journal-slider', SqshJournalSlider);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["kind-words-slider"] && !Shopify.designMode) return;
  try {
    
/** code **/
class SqshKindWords extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('.sqsh-kind-words__slide'));
    this.count = this.slides.length;
    if (this.count <= 1) return;

    this.index = 0;
    this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    this.querySelectorAll('[data-direction]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const dir = btn.getAttribute('data-direction');
        this.go(dir === 'next' ? this.index + 1 : this.index - 1);
        this.restart();
      });
    });

    this.autoplay = this.getAttribute('data-autoplay') === 'true';
    this.speed = parseInt(this.getAttribute('data-speed'), 10) || 6000;

    if (this.autoplay && !this.reduceMotion) {
      this.start();
      this.addEventListener('mouseenter', () => this.stop());
      this.addEventListener('mouseleave', () => this.start());
      this.addEventListener('focusin', () => this.stop());
      this.addEventListener('focusout', () => this.start());
    }
  }

  go(next) {
    const target = (next + this.count) % this.count;
    this.slides[this.index].classList.remove('is-active');
    this.slides[this.index].setAttribute('aria-hidden', 'true');
    this.index = target;
    this.slides[this.index].classList.add('is-active');
    this.slides[this.index].setAttribute('aria-hidden', 'false');
  }

  start() {
    this.stop();
    this.timer = setInterval(() => this.go(this.index + 1), this.speed);
  }

  stop() {
    if (this.timer) clearInterval(this.timer);
  }

  restart() {
    if (this.autoplay && !this.reduceMotion) this.start();
  }

  disconnectedCallback() {
    this.stop();
  }
}

if (!customElements.get('sqsh-kind-words')) {
  customElements.define('sqsh-kind-words', SqshKindWords);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sqsh-tailored-strategy"] && !Shopify.designMode) return;
  try {
    
/** code **/
if (!customElements.get('sqsh-parallax')) {
  class SqshParallax extends HTMLElement {
    connectedCallback() {
      this.media = this.querySelector('.sqsh-tailored__media-img');
      this.intensity = parseFloat(this.dataset.intensity || '0');
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (!this.media || this.reduce || this.intensity <= 0) return;

      this.ticking = false;
      this._onScroll = this._onScroll.bind(this);
      window.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onScroll, { passive: true });
      this._update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._onScroll);
      window.removeEventListener('resize', this._onScroll);
    }

    _onScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        this._update();
        this.ticking = false;
      });
    }

    _update() {
      const rect = this.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;

      const viewportCenter = window.innerHeight / 2;
      const elementCenter = rect.top + rect.height / 2;
      const delta = elementCenter - viewportCenter;
      const max = rect.height * 0.15;

      let offset = -delta * this.intensity;
      offset = Math.max(-max, Math.min(max, offset));

      this.media.style.transform = 'translate3d(0, ' + offset.toFixed(2) + 'px, 0)';
    }
  }

  customElements.define('sqsh-parallax', SqshParallax);
}

  } catch(e) { console.error(e); }
})();
})();
